var lx = lx || {};
lx.rating = lx.rating || {};

/* ex lxRating function */
lx.rating.load = function (pRec, pEty, pForm, pOpen, pThis) {
    var $container, dialog = false;
    if (pEty == 26) {
        if ($v("pFlowStepId") == 51) dialog = true;
        else $container = $("#bottom_list");
    } else if (pEty == 92) {
        console.log(pThis);
        $container = $(".rm_rating_plug");
        //$("#bottom_list").html("").show();
    } else {
        if ($(pThis).hasClass("t-Button")) $container = $(pThis).siblings(".rm_rating_plug");
        //else $container = $(pThis).parents(".rm_rating").siblings(".rm_rating_plug");
		else $container = $(pThis).parents(".profileContent").siblings(".rm_rating_plug");
        //$container.html("").hide();
    }
    console.log($container);
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=CPC_RATING",
            x01: pRec,
            x02: pEty,
            x03: pForm
        },
        success: function (d) {
            if (dialog) {
                lx.dialog.open({html: d, maxWidth: "600px"});
            } else {
                $container.html(d);/*.siblings(".rm_rating").addClass('open');*/
                if (pOpen) {
                    //
                    $container.animate({
                        height: "toggle"
                    }/*, {
                            duration: 1250,
                            specialEasing: {
                                height: "easeOutQuad"
                            }
                    }*/);
                    if (pEty == 26) {
                        var vTop = $container.offset().top;
                        $("html,body").animate({
                            scrollTop: (vTop - 140)
                        }, 1250);
                    }
                }
            }
        }
    });
};

/* ex lxRatingSubmit function */
lx.rating.submit = function (pRec, pEty, pThis) {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=CPC_RATING_SUBMIT",
            x01: pRec,
            x02: pEty,
            x03: $v("rating"),
            x04: $v("review"),
            x05: $v("ratingId")
        },
        success: function (d) {
            /*if (pEty == 26) {
                $("#bottom_list").html($(d).filter("#lx-rating-plugin"));
                $(".lxCatRating").replaceWith($(d).filter(".lxCatRating"));
            } else {*/
                $(pThis).parents('.rm_rating_plug').siblings(".rm_rating").replaceWith($(d).filter(".rm_rating"));
                $("#lx-rating-plugin").replaceWith($(d).filter("#lx-rating-plugin"));
            //}
        }
    });
}

lx.rating.close = function (pThis){
    $(pThis).parents('.rm_rating_plug').hide().html("").siblings('.rm_rating').removeClass('open');
}

lx.rating.edit = function (pThis){
    $(pThis).parents(".lxpComment").hide();
    $(".ratingEdit").show();
}

lx.rating.delete = function (pId, pThis){
    lx.load.add;
    apex.server.process( "CPC_RATING_DELETE", {
         x01: pId
        },{
         type: "GET",
         dataType: "html",
         success: function (d){
            lx.load.remove;
            if (d == "NOK"){
                lx.info.alert("Rating could not be deleted!");
            }else {
                //$(pThis).parents(".lxpComment").hide();
                $(pThis).parents('.rm_rating_plug').siblings(".rm_rating").replaceWith($(d).filter(".rm_rating"));
                lx.rating.close(pThis);
            }
         }
        });
}

/* ex lxSetStar function */
/*lx.rating.setStar = function (pNo) {
    $(".lx-star").removeClass("selected");
    $s("rating", pNo);
    for (var i = 1; i <= pNo; i++) {
        $("#star" + i).addClass("selected");
    }
};*/
/* ex lxSetStar function */
lx.rating.setStar = function (pId,pNo) {
	/*var p = pId.indexOf("P");
	alert(p);*/
	$("#"+pId+" .a-StarRating-stars-fg").css("width", 'calc(100%/5*'+pNo+')');//(12*pNo)+"px");
	$s("rating", pNo);
    /*$(".lx-star").removeClass("selected");
    $s("rating", pNo);
    for (var i = 1; i <= pNo; i++) {
        $("#star" + i).addClass("selected");
    }*/
};